import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a648d080"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "LargePickerContainer" };
const _hoisted_2 = { class: "PickerHeader" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lnr-arrow-left" }, null, -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "YearLabel" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "lnr-arrow-right" }, null, -1 /* HOISTED */));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "PickerBody" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "MonthLabel" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: _normalizeClass(["NavButton", { 'Disabled': !_ctx.canNavigateBack }]),
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.decrementYear && _ctx.decrementYear(...args)))
            }, _hoisted_4, 2 /* CLASS */),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.selectedYear), 1 /* TEXT */),
            _createElementVNode("div", {
                class: _normalizeClass(["NavButton", { 'Disabled': !_ctx.canNavigateForward }]),
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.incrementYear && _ctx.incrementYear(...args)))
            }, _hoisted_7, 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayMonths, (month) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: month.number,
                    class: _normalizeClass(["MonthContainer", { 'Selected': _ctx.selectedMonth === month.number, 'Disabled': month.isDisabled }]),
                    onClick: ($event) => (_ctx.monthSelected(month))
                }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(month.name), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_9));
            }), 128 /* KEYED_FRAGMENT */))
        ])
    ]));
}
